import React, {Component} from 'react'
import {inject, observer} from 'mobx-react'
import {Button, Form, Row, Col, Input} from 'antd'
import {PAGE_SIZE_DEFAULT} from '../../../constants/appConstant'
import {withTranslation} from 'react-i18next'

@inject('emailAddressStore', 'accountStore')
@observer
class SearchForm extends Component {
  state = {
  }
  formRef = React.createRef()

  componentDidMount() {
  }

  handleSearch = () => {
    const {emailAddressStore, record} = this.props
    const {searchItem} = emailAddressStore
    this.formRef.current.validateFields().then(fieldsValue => {
      let params = {
        id: record.id,
        marketGroupId: searchItem?.marketGroupId,
        keyword: fieldsValue?.keyword,
        page: 1,
        size: PAGE_SIZE_DEFAULT
      }
      emailAddressStore.onDetailsListAction(params)
    }).catch(err => {
    })
  }

  handleClear = () => {
    const {emailAddressStore, record} = this.props
    const {searchItem} = emailAddressStore
    emailAddressStore.onClearAction({
      "id": record?.id,
      "marketGroupId": searchItem?.marketGroupId
    })
  }
  render() {
    const {emailAddressStore, t} = this.props
    return (
      <>
        <Form ref={this.formRef} size="middle" className="searchForm" layout="vertical" style={{padding: 0}}>
          <Row gutter={[10, 10]}>
            <Col span={6}>
              <Form.Item name="keyword" rules={[{ message: `${t(`general.pleaseEnter`)} ${t(`emailSend.emailAddress`)}` }]}>
                <Input maxLength={100} placeholder={`${t(`general.pleaseEnter`)} ${t(`emailSend.emailAddress`)}`} allowClear/>
              </Form.Item>
            </Col>
            <Col span={18} style={{textAlign: 'right'}}>
              <Button onClick={this.handleSearch} type='danger'>{t(`general.search`)}</Button>
              <Button onClick={this.handleClear} type="primary">{t(`general.clear`)}</Button>
            </Col>
          </Row>
        </Form>
      </>
    )
  }
}

export default withTranslation()(SearchForm)
